import React, {useState} from 'react'
import { Container } from 'react-bootstrap'
import { Form } from 'react-bootstrap'

import { Button } from '@mui/material' 
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
// import '../utils/global.css'
import './contact-form.css'

const ContactForm = () => {

    const [sendData, setSendData] = useState({
        from_name: '',
        from_email: '',
        message: ''
    })

    const handleSubmit = (e) => {
        e.preventDefault();
    }

  return (
    <div className='contact'>
        <Container>
            <h1>Have an awesome idea?<br/> share with me 👇</h1>
            <Form className='contact-form' onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" required/>
                    <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicTextarea">
                    <Form.Label>Message</Form.Label>
                    <Form.Control as="textarea" rows={4} placeholder="A Message for Reho..." required/>
                </Form.Group>
                <Button variant='outlined' color='info' size='lg' endIcon={<ArrowOutwardIcon/>}>Submit</Button>
            </Form>
        </Container>
    </div>
  )
}

export default ContactForm